module.exports = __webpack_public_path__ + "static/media/chat-bubble.c5990b84.svg";